import { supabase } from "./supabaseClient";

export async function getSessionUser() {
    const { data } = await supabase.auth.getSession();
    return data.session?.user ?? null;
}

export async function isAdminUser() {
    const { data: sessionData } = await supabase.auth.getSession();
    const user = sessionData.session?.user;
    if (!user) return false;

    const { data, error } = await supabase
        .from("admins")
        .select("user_id")
        .eq("user_id", user.id)
        .maybeSingle();

    if (error) {
        console.warn("Admin check failed:", error.message);
        return false;
    }

    return !!data;
}
